// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__Lyb9m","info":"PatientInfo_info__2WfGF"};